import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';

export const Context = React.createContext();

export const useSearchContext = () => useContext(Context);

export const Provider = ({ search = {}, children }) => {
  const { query } = useRouter();
  const [alsoSearched, setAlsoSearched] = useState(false);

  const {
    'search-term': term,
    sortBy,
    page = 1,
    originalSearchTerm = undefined,
    suggestion,
    type,
    facetId,
  } = query;
  const searchTerm =
    type !== 's' ? term : facetId ? facetId[0].replace(/-/g, ' ') : undefined;

  const contextValue = {
    ...search,
    term: searchTerm,
    sortBy,
    page,
    originalSearchTerm,
    alsoSearched,
    setAlsoSearched,
    isSuggestionLink: suggestion?.split(':')[0] === 'true',
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};
